import React, {useState, useContext} from 'react';
import styled from 'styled-components';

import {OverlayContext} from './../contexts/OverlayContext';

import {OzContainer, OzButton, OzCard, OzInput} from '@ozwol/webui';

const Wrapper = styled.div`
`;

const Alert = ({
	title,
	text,
	onConfirm = () => {}, 
	onCancel = () => {}, 
	confirmLabel=null,
	confirmField=null,
	children = null
}) => {
  	const {removeOverlay} = useContext(OverlayContext);
	const [confirmTyped, setConfirmTyped] = useState("");

  	return (
		<>
			<OzContainer size="small">
				<OzCard
					footerLeft={<OzButton onClick={() => {removeOverlay("buttonwithalert"); onCancel();}} variant={"chetwodeblue-o"}>Cancel</OzButton>}
					footerRight={<OzButton disabled={confirmField && confirmTyped !== confirmField} onClick={() => {removeOverlay("buttonwithalert"); onConfirm();}} variant={"bittersweet"}>Confirm</OzButton>}
				>
					<b>{title}</b>
					<br/>
					<br/>
					{text}								
					{confirmField && confirmLabel ? 
							<OzInput
								label={confirmLabel}
								width="100%"
								value={confirmTyped}
                  				highlighted={confirmTyped && confirmTyped.length > 0}
								placeholder={confirmField}
								onChange={(val) => {
									setConfirmTyped(val);
								}}
							/>
					: null}
				</OzCard>
			</OzContainer>
		</>
  	)
}



const ButtonWithAlert = ({
	title,
	text,
	onConfirm = () => {}, 
	onCancel = () => {}, 
	confirmLabel=null,
	confirmField=null,
	children = null
}) => {
  	const {addOverlay} = useContext(OverlayContext);

  	return (
		<>
			<Wrapper onClick={() => addOverlay({
				reference: "buttonwithalert",
				content:
					<Alert
						title={title}
						text={text}
						onConfirm={onConfirm}
						onCancel={onCancel}
						confirmLabel={confirmLabel}
						confirmField={confirmField}
					/>
				})}>
				{children}
			</Wrapper>
		</>
  	)
}

export default ButtonWithAlert;
